var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TagSelectBloc',{attrs:{"title":_vm.$t('user.userSkills.skills'),"action-label":_vm.$t('user.userSkills.addSkill'),"tags":_vm.allSkills,"user-tags":_vm.skills,"editable":_vm.editable,"on-select":_vm.saveSkill,"on-delete":_vm.removeSkill}})
}
var staticRenderFns = []

export { render, staticRenderFns }